/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { GotoWaypointActionArgs } from "../goto_waypoint/goto_waypoint";

export const protobufPackage = "skills";

export interface AcquireGpsActionArgs {
  gotoWaypointActionArgs: GotoWaypointActionArgs | undefined;
}

export interface AcquireGpsResultData {
}

export interface AcquireGpsActionStateData {
}

function createBaseAcquireGpsActionArgs(): AcquireGpsActionArgs {
  return { gotoWaypointActionArgs: undefined };
}

export const AcquireGpsActionArgs = {
  encode(message: AcquireGpsActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.gotoWaypointActionArgs !== undefined) {
      GotoWaypointActionArgs.encode(message.gotoWaypointActionArgs, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AcquireGpsActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAcquireGpsActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.gotoWaypointActionArgs = GotoWaypointActionArgs.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AcquireGpsActionArgs {
    return {
      gotoWaypointActionArgs: isSet(object.gotoWaypointActionArgs)
        ? GotoWaypointActionArgs.fromJSON(object.gotoWaypointActionArgs)
        : undefined,
    };
  },

  toJSON(message: AcquireGpsActionArgs): unknown {
    const obj: any = {};
    if (message.gotoWaypointActionArgs !== undefined) {
      obj.gotoWaypointActionArgs = GotoWaypointActionArgs.toJSON(message.gotoWaypointActionArgs);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AcquireGpsActionArgs>, I>>(base?: I): AcquireGpsActionArgs {
    return AcquireGpsActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AcquireGpsActionArgs>, I>>(object: I): AcquireGpsActionArgs {
    const message = createBaseAcquireGpsActionArgs();
    message.gotoWaypointActionArgs =
      (object.gotoWaypointActionArgs !== undefined && object.gotoWaypointActionArgs !== null)
        ? GotoWaypointActionArgs.fromPartial(object.gotoWaypointActionArgs)
        : undefined;
    return message;
  },
};

function createBaseAcquireGpsResultData(): AcquireGpsResultData {
  return {};
}

export const AcquireGpsResultData = {
  encode(_: AcquireGpsResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AcquireGpsResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAcquireGpsResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): AcquireGpsResultData {
    return {};
  },

  toJSON(_: AcquireGpsResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<AcquireGpsResultData>, I>>(base?: I): AcquireGpsResultData {
    return AcquireGpsResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AcquireGpsResultData>, I>>(_: I): AcquireGpsResultData {
    const message = createBaseAcquireGpsResultData();
    return message;
  },
};

function createBaseAcquireGpsActionStateData(): AcquireGpsActionStateData {
  return {};
}

export const AcquireGpsActionStateData = {
  encode(_: AcquireGpsActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AcquireGpsActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAcquireGpsActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): AcquireGpsActionStateData {
    return {};
  },

  toJSON(_: AcquireGpsActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<AcquireGpsActionStateData>, I>>(base?: I): AcquireGpsActionStateData {
    return AcquireGpsActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AcquireGpsActionStateData>, I>>(_: I): AcquireGpsActionStateData {
    const message = createBaseAcquireGpsActionStateData();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
